import { colorsClassesMap, gradientsClassesMap } from '@cian/ui-kit-design-tokens/colors';
import colorStyles from '@cian/ui-kit-design-tokens/colors/gradients.module.css';
import deprecatedColorStyles from '@cian/ui-kit-design-tokens/colors/deprecated/colors.module.css';
import backgroundStyles from '@cian/ui-kit-design-tokens/colors/deprecated/backgrounds.module.css';
import borderColorStyles from '@cian/ui-kit-design-tokens/colors/deprecated/borderColors.module.css';
export function getColorProps(color) {
  const className = deprecatedColorStyles["color_".concat(color)];
  if (className) {
    return {
      className
    };
  }
  if (colorsClassesMap[color] || gradientsClassesMap[color]) {
    return {
      style: {
        color: "var(--".concat(color, ")")
      }
    };
  }
  return {
    style: {
      color
    }
  };
}
export function getBackgroundProps(background) {
  const className = backgroundStyles["background_".concat(background)];
  if (className) {
    return {
      className
    };
  }
  if (colorsClassesMap[background] || gradientsClassesMap[background]) {
    return {
      style: {
        background: "var(--".concat(background, ")")
      }
    };
  }
  return {
    style: {
      background
    }
  };
}
export function getBorderProps(_ref) {
  let {
    borderColor,
    borderStyle,
    borderWidth
  } = _ref;
  const style = {};
  const borderColorClassName = colorStyles["color_".concat(borderColor)] || borderColorStyles["borderColor_".concat(borderColor)];
  if (!borderColorClassName) {
    style.borderColor = borderColor;
  }
  if (borderStyle) {
    style.borderStyle = borderStyle;
  }
  if (borderWidth) {
    style.borderWidth = "".concat(borderWidth, "px");
  }
  return {
    style,
    className: borderColorClassName
  };
}